import BookingPathReviewBookingSummary from './BookingPathReviewBookingSummary';

export default BookingPathReviewBookingSummary;
